import { faFlask, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { useConfig, useProjects } from "../state";
import { TagButton } from "./TagButton";

export const ParcelThumbnail = ({ center }: { center: { coordinates: [number, number] } }) => {
  const config = useConfig();
  const gps = `${center.coordinates[0]},${center.coordinates[1]}`;
  const img = `${config.referenceUrl}/api/image/cadastre?c=${gps}&width=64&height=64`;
  const img2x = `${config.referenceUrl}/api/image/cadastre?c=${gps}&width=128&height=128`;
  return (
    <img
      src={img}
      srcSet={`${img} 1x, ${img2x} 2x`}
      alt=""
      className="w-10 h-10 rounded object-cover shrink-0 bg-gray-100"
    />
  );
};

export const ParcelRow = ({
  parcel,
  projectId,
  onSelect,
  onResearch,
}: {
  parcel: any;
  projectId: number;
  // Zonder handler navigeert een klik naar /location (ProjectBar). De workspace
  // geeft er een mee om binnen de eigen view te blijven.
  onSelect?: (parcel: any) => void;
  onResearch?: (parcel: any) => void;
}) => {
  const navigate = useNavigate();
  const removeParcelFromProject = useProjects((s) => s.removeParcelFromProject);

  const address = parcel.data?.addresses?.[0] as
    { street?: string; number?: string; city?: string } | undefined;
  const addressLine = address
    ? [[address.street, address.number].filter(Boolean).join(" "), address.city]
        .filter(Boolean)
        .join(", ")
    : null;

  return (
    <li className="flex items-start gap-2 rounded hover:bg-gray-50 px-2 py-1.5 group">
      <button
        onClick={() =>
          onSelect
            ? onSelect(parcel)
            : navigate(
                `/location/${parcel.center.coordinates[0].toFixed(5)},${parcel.center.coordinates[1].toFixed(5)}`
              )
        }
        className="flex items-start gap-2 text-left flex-1 min-w-0"
      >
        <ParcelThumbnail center={parcel.center} />
        <div className="flex-1 min-w-0">
          <div className="text-xs font-bold text-black truncate">{parcel.name}</div>
          {addressLine && <div className="text-xs text-gray-600 truncate">{addressLine}</div>}
          {parcel.description && (
            <div className="text-xs text-gray-500 truncate">{parcel.description}</div>
          )}
        </div>
      </button>
      <div className="flex items-center gap-1 mt-1 shrink-0">
        {onResearch && (
          <button
            onClick={() => onResearch(parcel)}
            className="text-gray-400 hover:text-dark-green"
            title="Onderzoek deze kavel"
            aria-label={`Onderzoek ${parcel.name}`}
          >
            <FontAwesomeIcon icon={faFlask} size="xs" />
          </button>
        )}
        <TagButton parcel={parcel} projectId={projectId} variant="compact" />
        <button
          onClick={() => {
            if (confirm("Perceel verwijderen?")) removeParcelFromProject(projectId, parcel.id);
          }}
          className="text-gray-300 hover:text-red-500 group-hover:opacity-100"
        >
          <FontAwesomeIcon icon={faTrashCan} size="xs" />
        </button>
      </div>
    </li>
  );
};
